import PropTypes from "prop-types";

export const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  fullWidth: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  asterisk: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  variant: PropTypes.oneOf(["outlined", "filled"], "standard"),
  shrink: PropTypes.bool,
  multiline: PropTypes.bool,
  maxRows: PropTypes.bool,
  defaultValue: PropTypes.bool,
  rows: PropTypes.string,
  color: PropTypes.string,
  focused: PropTypes.bool,
  helperText: PropTypes.string,
};
